<template>
  <b-navbar
    class="havas-background"
    :mobile-burger="false"
    fixed-top>
    <template slot="brand">
      <b-navbar-item class="pl-20">
        <img
          v-if="urlLogo"
          :src="urlLogo"
          class="havas-logo"
          ref="logo">
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  computed: {
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    urlLogo() {
      return this.societe?.urlLogo;
    },
  },
}
</script>
